'use client';

import { useAtom } from 'jotai';
import { shouldDisconnectWalletAtom } from '@/store';

/**
 * 统一的钱包断连 hook
 * 用于在非 wagmi provider 层级触发钱包断连
 */
export function useWalletDisconnect() {
  const [, setShouldDisconnectWallet] = useAtom(shouldDisconnectWalletAtom);

  const triggerDisconnect = () => {
    setShouldDisconnectWallet(true);
  };

  return { triggerDisconnect };
}
